import React, {useCallback, useEffect} from "react";
import {observer} from "mobx-react";
import {ProfileBoxMessagesIndicator} from "../profile-box-messages-indicator.component";
import {
    TOOLTIP_TARGET_MAGIC_888_BALL_INDICATOR
} from "../../../services/tooltip/on-boarding-tooltip/on-boarding-tooltip-target-selectors";
import {useServices} from "../../../react-hooks/use-services.hook";
import {IGCIndicatorBallWrapperDefaultBox} from "../boxes/igc-indicator/ball-wrapper.default.box";
import {IGCIndicatorProgressPieBox} from "../boxes/igc-indicator/progress-pie.box";
import {IndicatorLayout} from "../consts/indicator-layout";


export const InGameChallengeIndicator: React.FC = observer((props) => {
    const services = useServices();
    const percentage = services.inGameChallenge.currentProgressPercentage;
    const allCActiveChallengesCompleted = services.magic8ball.allActiveCampaignRulesCompleted;
    const hasAvailableTickets = services.inGameTicket.hasAvailableTickets;
    const isAllChallengesCompleted = allCActiveChallengesCompleted  && !hasAvailableTickets;

    const _sendAnalytics = useCallback((action: string, label: string) => {
        services.inGameChallenge.sendAnalytics(action, label);
    }, [services.inGameChallenge]);

    useEffect(() => {
        _sendAnalytics('Show', 'IGCIconLobby');
    }, [_sendAnalytics]);


    const renderMagic888BallIcon = () => {
        return (<IGCIndicatorBallWrapperDefaultBox onClick={() => _sendAnalytics('Click', 'IGCIconLobby')}>
            <IGCIndicatorProgressPieBox>
                <svg viewBox="0 0 30 30">
                    <circle
                        id="outline"
                        r="15" cx="15" cy="15"
                        strokeWidth={3}
                    ></circle>
                    <circle
                        id="progress"
                        r="15" cx="15" cy="15" strokeLinecap="round"
                        strokeWidth={3}
                        strokeDasharray={percentage * 2 * Math.PI * 15 / 100 + ", " + (2 * Math.PI * 15)}
                    ></circle>
                </svg>
            </IGCIndicatorProgressPieBox>
        </IGCIndicatorBallWrapperDefaultBox>);
    }

    return (
        <ProfileBoxMessagesIndicator
            numberOfAwaitingMessages={services.inGameTicket.availableTickets.length}
            className={TOOLTIP_TARGET_MAGIC_888_BALL_INDICATOR}
            iconComponent={renderMagic888BallIcon}
            primaryText='Magic 888 Ball'
            label={allCActiveChallengesCompleted ? `${services.translation.translate('MAGIC_8_BALL_ALL_RULES_COMPLETED_CONGRATS')}!` : null}
            onClick={isAllChallengesCompleted ? null : () => services.magic8ball.showMagicBall()}
            forceOnClickWork={true}
            displayLayout={IndicatorLayout.FullWidth}
        />
    );
});
